import produce from 'immer';

import { generateMTTReducer } from '@swf/poker';

import type { PassBundleRaw, RawStep } from '../types';
import { generateStepKey } from '../utils';

import { defaultState } from './defaultState';
import type { PokerPowerPathState as State } from './types';

export const reducers = {
  ...generateMTTReducer<State>(defaultState),
  clear: (): State => produce(defaultState, (draft) => draft),
  dataRequested: (state: State): State => ({
    ...state,
    isLoading: true
  }),
  dataLoadFailure: (state: State): State => ({
    ...state,
    isLoading: false,
    hasDataError: true
  }),
  updateSteps: (state: State, stepsResponse: RawStep[]): State =>
    produce(state, (draftState) => {
      draftState.isLoading = false;
      draftState.steps = { ...defaultState.steps };
      for (const step of stepsResponse) {
        const key = generateStepKey(step.step, step.type);
        draftState.steps[key] = {
          ...step,
          key,
          formattedBuyIn: step.buyIn + step.fee,
          whenStartInt: step.whenStart_t,
          regEndInt: step.regEnd_t,
          whenStart: step.whenStart?.toString() || ''
        };
      }
    }),
  setPassesError: (state: State, payload: string) => ({
    ...state,
    passesData: { ...defaultState.passesData },
    passesError: payload
  }),
  setPassesData: (state: State, payload: PassBundleRaw) => ({
    ...state,
    passesData: payload,
    hasPreloaded: true
  })
};
